<template>
  <div />
</template>

<script>
import AuthService from '@/services/AuthService';
import TrendyolAssistantLib from '@customer-service/assistant-ui-lib';

export default {
  name: 'Logout',

  async created () {
    try {
      AuthService.logout();
    } finally {
      await TrendyolAssistantLib.clearWithUrl(process.env.VUE_APP_LIVE_CHAT_URL).catch(() => {});

      let url = '/account/login';

      if (window.location.search) {
        url = `${url}${window.location.search}`;
      }

      window.location.href = url;
    }
  },
};
</script>

<style lang="scss" scoped>

</style>
